import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';

// Backend response shape: { date: "YYYY-MM-DD", slots: ["HH:mm", ...] }
interface SlotsDayResponse {
  date: string;
  slots: string[]; // HH:mm — faqat mavjud vaqtlar
}

export const clientSlotsApi = {
  /**
   * Tanlangan kun uchun bo'sh vaqtlarni qaytaradi.
   * @returns HH:mm formatdagi string massiv, masalan ["09:00", "09:30"]
   */
  getSlots: async (params: {
    providerId: number;
    serviceId: number;
    date: string; // YYYY-MM-DD
  }): Promise<string[]> => {
    const res = await apiClient.get<ApiResponse<SlotsDayResponse>>(API_PATHS.CLIENT_SLOTS, {
      params,
    });
    const data = res.data.data;
    return Array.isArray(data?.slots) ? data.slots : [];
  },

  /**
   * Keyingi bo'sh vaqt mavjud bo'lgan kunni qaytaradi.
   * @returns { date, slots } yoki null (hech qanday mavjud emas)
   */
  getNextAvailable: async (params: {
    providerId: number;
    serviceId: number;
  }): Promise<SlotsDayResponse | null> => {
    const res = await apiClient.get<ApiResponse<SlotsDayResponse | null>>(
      API_PATHS.CLIENT_SLOTS_NEXT,
      { params },
    );
    return res.data.data ?? null;
  },
};
